import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * TableView class extending JetView to create a data table.
 */
export default class TableView extends JetView {
    /**
     * Configures the layout of the TableView.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'datatable', // Data table view
                            id: 'datatable', // ID for the data table
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
                            height: screen.width < 820 ? 405 : 0, // Conditional height based on screen width
                            columns: [
                                // Column definitions for the data table
                                {
                                    id: 'UserId',
                                    header: _('ID Usuario'), // Localized header
                                    width: 100,
                                },
                                {
                                    id: 'Country',
                                    header: _('País'), // Localized header
                                    hidden: !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility based on permissions
                                    css: 'prm-filterByCountry', // CSS class for styling
                                    width: 250,
                                    sort: 'int', // Sorting type
                                    template: '{common.treetable()}  #Country#', // Template for displaying country
                                },
                                {
                                    id: 'TypeDevice',
                                    header: _('Dispositivo'), // Localized header
                                    editor: 'combo', // Combo editor for this column
                                    options: [
                                        // Options for the combo editor
                                        {
                                            id: '1',
                                            value: "<span class='icon-phone'></span>", // Icon for phone
                                        },
                                        {
                                            id: '2',
                                            value: "<span class='icon-display'></span>", // Icon for display
                                        },
                                        {
                                            id: '3',
                                            value: "<span class='icon-phone'></span><span class='icon-display'></span>", // Icon for both
                                        },
                                    ],
                                    width: 90,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'DateRegistration',
                                    header: _('Fecha Registro'), // Localized header
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 150,
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date formatting
                                },
                                {
                                    id: 'MediaId',
                                    header: _('Media ID'), // Localized header
                                    width: 100,
                                },
                                {
                                    id: 'LinkId',
                                    header: _('Link ID'), // Localized header
                                    width: 100,
                                },
                                {
                                    id: 'DateFirstDeposit',
                                    header: _('Fecha Primer Depósito'), // Localized header
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 150,
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date formatting
                                },
                                {
                                    id: 'AmountDateFirst',
                                    header: _('Valor Primer Depósito'), // Localized header
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    width: 150,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'BetShopName',
                                    header: _('Punto de Venta'), // Localized header
                                    width: 150,
                                },
                            ],
                            ready: function () {
                                // Function executed when the data table is ready
                                if (!this.count()) {
                                    // Check if there are no rows
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        // Show overlay message
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                            // API URL for loading data
                            url: devConfig.geturlApi() + 'BetShop/GetAffiliatesBetShop',
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the data table and sets up event listeners.
     * @param {Object} grid - The data table instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the data table instance
        const _ = this.app.getService('locale')._; // Localization service
        var url = grid.data.url; // URL for data loading
        var filter = ''; // Filter string

        // Event listener for filtering data
        this.on(this.app, 'affiliatesBetShop:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate over filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'DateRegistration') {
                        // Handle date registration filter
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to filter
                    } else {
                        if (object[i][0] == 'DateFirstDeposit') {
                            // Handle first deposit date filter
                            var date = object[i][1].split(' - '); // Split date range
                            string1 = string1 + '&dateFrom2=' + date[0]; // Add start date to filter
                            string1 = string1 + '&dateTo2=' + date[1]; // Add end date to filter
                        } else {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate over object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom = // Format start date
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo = // Format end date
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter string
        });
    }
}

// FILE DOCUMENTED
